import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { FavoriteDB } from 'src/data/datatypes';
import { createOrUpdateFavorite, deleteFavorite, getFavorite } from 'src/services/DBService/DbService';
import ConfirmPopup from '../molecules/ConfirmPopup';
import Modal from '../molecules/Modal';
import { getFavoriteId } from '../organisms/Sessions/Session.logic';
import favoriteIcon from '../../static/icons/icon_favorite.svg';
import favoriteFillIcon from '../../static/icons/icon_favorite_fill.svg';

const TopBarFavoriteButton = (props: {}) => {
    const location = useLocation();
    const favoriteId = getFavoriteId(location.pathname);
    const [title, setTitle] = useState<string>('');
    const [favorite, setFavorite] = useState<FavoriteDB>();
    const [showCreate, setShowCreate] = useState<boolean>(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState<boolean>(false);

    useEffect(() => {
        const loadData = async () => {
            const fav = await getFavorite(favoriteId);
            setFavorite(fav);
            if (fav !== undefined) {
                setTitle(fav.title);
            } else {
                setTitle('');
            }
        };
        loadData();
    }, [favoriteId]);

    const createFavorite = useCallback(async (ev: React.MouseEvent<HTMLButtonElement>) => {
        ev.stopPropagation();
        const fav = {
            _id: favoriteId,
            title
        };
        await createOrUpdateFavorite(fav);
        setFavorite(fav);
        setShowCreate(false);
    }, [favoriteId, title]);

    const deletePageFromFavorite = useCallback(async () => {
        if (favorite !== undefined) {
            await deleteFavorite(favorite._id);
            setFavorite(undefined);
            setTitle('');
        }
        setShowDeleteDialog(false);
    }, [favorite]);

    const cancelFavoriteCreation = useCallback(async (ev: React.MouseEvent<HTMLButtonElement>) => {
        ev.stopPropagation();
        setShowCreate(false);
    }, []);

    const toggleFavorite = useCallback(async () => {
        if (favorite !== undefined) {
            setShowDeleteDialog(true);
        } else {
            setShowCreate(true);
        }
    }, [favorite]);

    let iconImage = <img src={favoriteIcon} />;
    if (favorite !== undefined) {
        iconImage = <img src={favoriteFillIcon} />;
    }

    const creatingDisabled = title === '';

    return (
        <>
            <button
                className="button icon-button"
                onClick={toggleFavorite}
            >
                {iconImage}
            </button>
            {showCreate &&
                <Modal>
                    <div className="add-favorite-modal">
                        <div>
                            <h3>
                                Seite als Favorit speichern:
                            </h3>
                        </div>
                        <div className="add-favorite-modal-title-input">
                            <input type="text" value={title} placeholder="Beschreibung*" onChange={ev => setTitle(ev.target.value)} />
                        </div>
                        <div className="add-favorite-modal-button-bar">
                            <button className="favorite-button-remove" onClick={cancelFavoriteCreation}>Abbrechen</button>
                            <button className="favorite-button-add" disabled={creatingDisabled} onClick={createFavorite}>Speichern</button>
                        </div>
                    </div>
                </Modal>
            }
            {showDeleteDialog &&
                <ConfirmPopup
                    title="Favorit löschen"
                    text="Diese Seite aus der Favoritenliste entfernen?"
                    confirmLabel="Ja"
                    dismissLabel="Nein"
                    onConfirmClicked={deletePageFromFavorite}
                    onDismissClicked={() => setShowDeleteDialog(false)}
                />
            }
        </>
    );
};

export default TopBarFavoriteButton;
